import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { Z_INDEX_LOW } from '@Styles/constants/layout'
import { RADIUS_1 } from '@Styles/constants/radius'

import { odsearchFieldset } from '../common/styles'

export const odSearchStickyResponsive = css({
  position: 'relative',
})

export const odsearchStickyFieldset = (theme: Theme): SerializedStyles =>
  css(odsearchFieldset, {
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  })

export const originInputPlaceStickyResponsive = (theme: Theme, isSwapVisible: boolean): SerializedStyles =>
  css({
    borderRadius: `${RADIUS_1} ${RADIUS_1} 0 0`,
    paddingRight: isSwapVisible ? theme.spacing(9) : theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      borderRadius: `${RADIUS_1} 0 0 ${RADIUS_1}`,
      paddingLeft: theme.spacing(2),
      paddingRight: isSwapVisible ? theme.spacing(4.5) : theme.spacing(2),
    },
  })

export const destinationInputPlaceStickyResponsive = (theme: Theme, isSwapVisible: boolean): SerializedStyles =>
  css({
    borderRadius: `0 0 ${RADIUS_1} ${RADIUS_1}`,
    paddingRight: isSwapVisible ? theme.spacing(9) : theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      borderRadius: `0 ${RADIUS_1} ${RADIUS_1} 0`,
      paddingLeft: isSwapVisible ? theme.spacing(4.5) : theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  })

export const separatorStickyResponsive = (theme: Theme): SerializedStyles =>
  css({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    zIndex: Z_INDEX_LOW,
    [theme.breakpoints.up('md')]: {
      height: '100%',
      position: 'absolute',
      right: '50%',
      top: '50%',
      transform: 'translate(50%, -50%)',
      width: rem(2),
      zIndex: Z_INDEX_LOW,
    },
  })

export const absoluteStickyResponsive = (theme: Theme): SerializedStyles =>
  css({
    position: 'absolute',
    right: theme.spacing(2),
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: Z_INDEX_LOW,
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      right: '50%',
      top: '50%',
      transform: 'translate(50%, -50%)',
      zIndex: Z_INDEX_LOW,
    },
  })
